import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Spinner,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import showNotification from "../../helpers/show_notification";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { postSubmitForm } from "../../helpers/forms_helper";
// actions
import exportFromJSON from "export-from-json";
import printDiv from "../../helpers/print_data";
import preloader from "../../helpers/preloader";
import ReactSelect from "react-select";

const AllVehicles = (props) => {
  const { SearchBar } = Search;
  useEffect(() => {
    loadAllVehicles();
    loadAllStores();
  }, []);

  const [allVehicles, setAllVehicles] = useState([]);
  const loadAllVehicles = async () => {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "vehicles/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const transformedData = response.data.map(item => {
        return {
          ...item,
          branchesString: item.branches.map((branch) => branch.name).join(", "),
          branches: item.branches.map(branch => ({
            ...branch,
            label: branch.name,
            value: branch.branch_id 
          }))
        };
      });
      preloader(false)
      setAllVehicles(transformedData);
    } else {
      preloader(false)
      showNotification(response.message, "Error");
    }
  };

  const [selectedStores, setSelectedStores] = useState([]);
  const [allStores, setAllStores] = useState([]);
  const loadAllStores = async () => {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      preloader(false)
      let branches = response.data.filter((ob) => ob.type === "Branch" || ob.type === "CENTRAL KITCHEN STORE")
      setAllStores(branches);
    } else {
      preloader(false)
      showNotification(response.message, "Error");
    }
  };


  const [isLoading, setIsLoading] = useState(false)
  const handleValidUpdate = async (e, v) => {
    try {
      if(!selectedStores || selectedStores?.length<=0){
        showNotification("Please select atleast one branch","Warning")
        return
      }
      const payload = {
        id: selectedVehicles._id,
        name: v.name,
        branches:selectedStores?.map(store=>({branch_id:store.value}))
      };
      setIsLoading(true)
      let url = process.env.REACT_APP_BASEURL + "vehicles/update";
      let response = await postSubmitForm(url, payload);
      if (response.status === 1) {
        loadAllVehicles();
        setEditModal(!editModal);
        showNotification(response.message, "Success");
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsLoading(false)
    }
  };

  const [selectedVehicles, setSelecetedVehicle] = useState();
  const [editModal, setEditModal] = useState();
  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
      text: props.t("Vehicle/Driver"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Branches"),
      sort: false,
      dataField:"branchesString",
      formatter: (cell, row) => {
        return (
          <>
            {row.branches.map((obj) => {
              return (
                <span class="font-size-12 mr-2 badge-soft-success badge badge-success badge-pill">
                  {obj.name}
                </span>
              );
            })}
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "40%" };
      },
    },
    {
      text: props.t("Action"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <span className="text-info">
            <i
              className="bx bxs-edit font-size-15"
              title="Click to Edit"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setEditModal(!editModal);
                setSelecetedVehicle(row);
                setSelectedStores(row.branches)
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];
  const handleDownload = async () => {
    const fileName = "All Vehicles/Drivers";
    const exportType = "xls";

    let data_to_export = allVehicles;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          "Vehicle/Driver": v.name,
          Branches: v.branches.map((obj)=>obj.name).join(", "),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const customStyles = {
    multiValue: (base, state) => ({
      ...base,
      backgroundColor: "#daebc0",
      color: "#719639",
    }),
    multiValueLabel: (base, state) => ({
      ...base,
      color: "#719639",
    }),
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Vehicles/Driver")}
            breadcrumbItem={props.t("Update Vehicles/Driver")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("All Vehicles/Drivers")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t( "View/Update all your existing vehicles/drivers here")}
                  </CardSubtitle>

                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary mr-2"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>

                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allVehicles && allVehicles}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              {" "}
                              <CardTitle>All Vehicles/Drivers</CardTitle>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="lg"
                    isOpen={editModal}
                    toggle={() => setEditModal(!editModal)}
                  >
                    <ModalHeader toggle={() => setEditModal(!editModal)}>
                      {props.t("Update")}
                    </ModalHeader>
                    <ModalBody>
                      {selectedVehicles && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <AvForm onValidSubmit={handleValidUpdate}>
                                    <Row>
                                      <Col lg={6} sm={12} md={12}>
                                        <AvField
                                          name="name"
                                          value={selectedVehicles.name}
                                          label={props.t("Vehicles/Driver")}
                                          placeholder={props.t(
                                            "Enter Vehicles/Driver Name"
                                          )}
                                          type="text"
                                          validate={{
                                            required: {
                                              value: true,
                                              errorMessage: props.t(
                                                "Name cannot be empty"
                                              ),
                                            },
                                          }}
                                        />
                                      </Col>
                                      <Col lg={6} sm={12} md={12}>
                        <Label>{props.t("Branches")}</Label>
                        <ReactSelect
                          isMulti
                          name="branches"
                          options={allStores}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={customStyles}
                          value={selectedStores}
                          onChange={setSelectedStores}
                          placeholder={props.t("Select Branches...")}
                        />
                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg={12}>
                                        <hr />
                                        <FormGroup className="mb-0 text-center">
                                          <div>
                                            <Button
                                              type="submit"
                                              color="primary"
                                              disabled={isLoading}
                                              style={{width:"100px"}}
                                              className="mr-1"
                                            >
                                              {isLoading ? <Spinner size={"sm"} /> : props.t("Update")}
                                            </Button>
                                          </div>
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </AvForm>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(AllVehicles))
);
